import { render, staticRenderFns } from "./DesignInspectionButton.vue?vue&type=template&id=15d17612&scoped=true"
import script from "./DesignInspectionButton.vue?vue&type=script&lang=ts"
export * from "./DesignInspectionButton.vue?vue&type=script&lang=ts"
import style0 from "./DesignInspectionButton.vue?vue&type=style&index=0&id=15d17612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d17612",
  null
  
)

export default component.exports